import Button from "@material-ui/core/Button";
import makeStyles from "@material-ui/core/styles/makeStyles";
import React from "react";
// import { updateSearchParam } from "../../../helpers/ScannersBijFunctions";
// import { UrlParamsContext } from "../../../templates/context";

const useBackToTopLinkStyles = makeStyles((theme) => ({
  root: {
    // Hide "Export", divider and "Back to top" for single page exports
    ".spe & *": {
      display: "none"
    },
    display: "flex",
    justifyContent: "flex-end",
    textTransform: "uppercase",
    position: "absolute",
    top: 0,
    right: 0,
    left: 0,
    marginTop: "16px",
    marginRight: "16px",
    marginLeft: "16px",
    "& .export-sheet-btn, & a": {
      textDecoration: "none",
      width: "auto",
      height: "auto",
      padding: 0,
      color: theme.palette.primary.main,
      ...theme.typography.caption,

      "&, &:hover": {
        background: "none"
      }
    },
    "& img": {
      width: "11px",
      marginRight: "2px"
    }
  },
  dividerStyle: {
    backgroundColor: theme.palette.divider,
    height: "14px",
    margin: "0px 8px"
  }
}));

export default function LandingTopLinks(props) {
  const classes = useBackToTopLinkStyles();
  const { topLink, sheetId } = props;
  return (
    <div className={classes.root}>
      {topLink.export_link_label && (
        <React.Fragment>
          <Button
            href={topLink.export_link_url}
            className="export-sheet-btn"
            data-sheet-id={sheetId}
            data-mapping-enabled="true"
          >
            <img src={topLink.export_link_icon_url} alt="" />
            {topLink.export_link_label}
          </Button>
        </React.Fragment>
      )}
    </div>
  );
}
